import { Platform } from 'react-native';

type BeforeInstallPromptChoice = {
  outcome: 'accepted' | 'dismissed';
  platform: string;
};

export type BeforeInstallPromptEvent = Event & {
  platforms?: string[];
  prompt: () => Promise<void>;
  userChoice: Promise<BeforeInstallPromptChoice>;
};

export function isWebPlatform() {
  return Platform.OS === 'web' && typeof window !== 'undefined';
}

export function isStandalonePwa() {
  if (!isWebPlatform()) {
    return false;
  }

  const navigatorWithStandalone = navigator as Navigator & {
    standalone?: boolean;
  };

  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.matchMedia?.('(display-mode: fullscreen)').matches ||
    navigatorWithStandalone.standalone === true
  );
}

export function isIosSafari() {
  if (!isWebPlatform()) {
    return false;
  }

  const userAgent = navigator.userAgent;
  const isIos = /iPad|iPhone|iPod/.test(userAgent);
  const isWebKit = /WebKit/.test(userAgent);
  const isOtherIosBrowser = /CriOS|FxiOS|EdgiOS|OPiOS/.test(userAgent);

  return isIos && isWebKit && !isOtherIosBrowser;
}

export function supportsWebPushApis() {
  return (
    isWebPlatform() &&
    'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window
  );
}

export function currentNotificationPermission() {
  if (!isWebPlatform() || !('Notification' in window)) {
    return 'unsupported' as const;
  }

  return Notification.permission;
}
